import { collection, query, where, orderBy, getDocs } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Build final user roadmap from Firebase admin data
 */
export async function buildUserRoadmapFromFirebase({
  roadmapMetaId,
  selectedPhases,
  maxWeeks,
}) {
  /* 1️⃣ Fetch phases */
  const phasesSnap = await getDocs(
    query(
      collection(db, "roadmap_phases"),
      where("roadmapId", "==", roadmapMetaId)
    )
  );

  /* 2️⃣ Fetch weeks */
  const weeksSnap = await getDocs(
    query(
      collection(db, "roadmap_weeks"),
      where("roadmapId", "==", roadmapMetaId)
    )
  );

  /* 3️⃣ Fetch days */
  const daysSnap = await getDocs(collection(db, "roadmap_days"));

  /* ---------- Group weeks by phase ---------- */
  const weeksByPhase = {};
  weeksSnap.docs.forEach((doc) => {
    const w = doc.data();
    if (!weeksByPhase[w.phaseId]) {
      weeksByPhase[w.phaseId] = [];
    }
    weeksByPhase[w.phaseId].push({
      id: doc.id,
      ...w,
    });
  });

  /* ---------- Group days by week ---------- */
  const daysByWeek = {};
  daysSnap.docs.forEach((doc) => {
    const d = doc.data();
    if (!daysByWeek[d.weekId]) {
      daysByWeek[d.weekId] = [];
    }
    daysByWeek[d.weekId].push({
      dayId: doc.id,
    });
  });

  /* ---------- Build final reference roadmap ---------- */
  return phasesSnap.docs
    .map((phaseDoc) => {
      const phase = phaseDoc.data();

      if (!selectedPhases.includes(phase.phaseKey)) return null;

      const weeks = (weeksByPhase[phaseDoc.id] || [])
        .sort((a, b) => a.order - b.order)
        .slice(0, maxWeeks)
        .map((week) => ({
          weekId: week.id,
          days: daysByWeek[week.id] || [],
        }));

      return {
        phaseId: phaseDoc.id,
        phaseKey: phase.phaseKey,
        weeks,
      };
    })
    .filter(Boolean);
}
